import { Button } from '@apollo/orbit';
import React from 'react';
import { useHistory, useLocation } from 'react-router-dom';

import { getOnboardingVariant } from 'src/lib/analytics/amplitude/helpers/getOnboardingVariant';
import { ampli } from 'src/lib/analytics/amplitude/vendor';
import Config from 'src/lib/config';
import { setOverlayVisibleLocation } from 'src/lib/routing';

export const LegacyCallToAction = ({
  planName,
}: {
  planName: string | undefined;
}) => {
  const location = useLocation();
  const history = useHistory();
  return (
    <>
      <Button
        size="md"
        variant="primary"
        className="my-6"
        onClick={async () => {
          ampli.connectGraphFlowStarted({
            'API Type': 'GraphQL',
            OnboardingVariant: getOnboardingVariant(planName),
          });
          history.push(
            setOverlayVisibleLocation({
              location,
              overlayName: Config.modals.createGraph,
            }),
          );
        }}
      >
        Create your first graph
      </Button>
      <div className="text-base text-secondary">
        Continue with this option if you want to host your own supergraph
        endpoint, or if you’re creating a non-federated (monolith) graph.
      </div>
    </>
  );
};
